module.exports = __webpack_public_path__ + "static/media/balance_1_백색소음기.3040ef73.jpg";